import { lazy } from 'react'

export const GenderV1 = lazy(() => import('./v1/GenderV1'))
export const GenderV2 = lazy(() => import('./v2/GenderV2'))
export const GenderV3 = lazy(() => import('./v3/GenderV3'))
export const GenderV4 = lazy(() => import('./v4/GenderV4'))
export const GenderV5 = lazy(() => import('./v5/GenderV5'))
export const GenderV6 = lazy(() => import('./v6/GenderV6'))
